import classnames from 'classnames';
import pick from 'lodash/pick';
import { bool, node, string } from 'prop-types';
import React from 'react';
import { GoLink } from 'react-icons/go';
import { Link } from 'react-router-dom';

function IconLink({ children, showIcon, className, disabled, ...props }) {
  return (
    <Link
      {...pick(props, ['to', 'title', 'target'])}
      disabled={disabled}
      className={classnames(className, { disabled })}
    >
      {showIcon && <GoLink />}
      {children}
    </Link>
  );
}

IconLink.propTypes = {
  children: node.isRequired,
  showIcon: bool,
  className: string,
  disabled: bool,
};

IconLink.defaultProps = {
  showIcon: false,
  className: '',
  disabled: false,
};

export default IconLink;
